import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTimeAcknowledgedState = atom({
  key: "myTimeAcknowledgedState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
